var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-search-footer texture-light"},[_c('a',{staticClass:"see-all-results",attrs:{"href":_vm.seeAllResultsPath}},[_vm._v("\n    See All Results for \""+_vm._s(_vm.queryString)+"\"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }